export default
{
  UnitTypes: [],
  UnitType: {},
}
